export default __webpack_public_path__ + "static/media/background1.56c811f7.png";